import Vue from 'vue';
import vueOnlineProp from 'vue-online-prop'

Vue.use(vueOnlineProp)
